import React from 'react';
import { connect } from 'redux-bundler-react';
import NotificationSystem from 'react-notification-system';

class NotificationPane extends React.Component {

  constructor(props){
    super(props);
    this.fireNotification = this.fireNotification.bind(this);
  }

  fireNotification(){
    const { activeNotification, doClearNotification } = this.props;
    if(activeNotification){
      this.notificationPane.addNotification(activeNotification);
      doClearNotification();
    }
  }

  componentDidUpdate(){
    const { activeNotification } = this.props;
    if(activeNotification) this.fireNotification();
  }

  componentDidMount(){
    const { activeNotification } = this.props;
    if(activeNotification) this.fireNotification();
  }

  render(){
    return (
      <div className="notification-pane">
        <NotificationSystem ref={(el)=>{this.notificationPane = el}} />
      </div>
    )
  }
}

export default connect(
  'selectActiveNotification',
  'doClearNotification', 
  NotificationPane
);